import React, { useState } from 'react';
import RxCell from '@components/cart/rx/RxCell';
import { RX_CELL_TYPES } from '@utils/enums';
import DoctorModal from '@components/cart/rx/DoctorModal';

const RxCells = ({ item, bundleKey }) => {
	const [selectedRx, setSelectedRx] = useState(item.properties._submissionMethod);
	const [isModalDisplayed, setIsModalDisplayed] = useState(false);

	const onCartPage = window.location.href.includes('/cart');

	return onCartPage ? (
		<div className='cell__container'>
			<RxCell
				title='Remind me later'
				label='Easiest'
				cellType={RX_CELL_TYPES.REMIND}
				isRadio
				item={item}
				isSelected={selectedRx === RX_CELL_TYPES.REMIND}
				setSelectedRx={setSelectedRx}
				bundleKey={bundleKey}
				subcopy='No problem. Place your order now and get reminded later.'
			/>
			<RxCell
				title='Upload a photo'
				label='Fastest'
				cellType={RX_CELL_TYPES.PHOTO}
				isRadio
				item={item}
				isSelected={selectedRx === RX_CELL_TYPES.PHOTO}
				setSelectedRx={setSelectedRx}
				bundleKey={bundleKey}
				subcopy='A photo of your prescription is perfect!'
			/>
			<RxCell
				title='Have us contact your doctor'
				cellType={RX_CELL_TYPES.DOCTOR}
				isRadio
				item={item}
				isSelected={selectedRx === RX_CELL_TYPES.DOCTOR}
				setSelectedRx={setSelectedRx}
				bundleKey={bundleKey}
				subcopy='Enter in your eye doctor’s info, and we’ll reach out to obtain your prescription.'
				setIsModalDisplayed={setIsModalDisplayed}
			/>
			<DoctorModal
				bundleKey={bundleKey}
				isDisplayed={isModalDisplayed}
				onSubmit={() => {
					setIsModalDisplayed(false);
					setSelectedRx(RX_CELL_TYPES.DOCTOR);
				}}
				onCancel={() => {
					setIsModalDisplayed(false);
				}}
				item={item}
			/>
		</div>
	) : null;
};

export default RxCells;
